module.exports = __webpack_public_path__ + "media/images/pricing-151fdd12b0b0e642f8a8dbce23ff6fbe.png";